/* AsPadel — frise de livraison sous le bouton d'achat.
   Les dates se calculent dans le navigateur, à l'heure de Paris : côté serveur,
   la page serait mise en cache et afficherait des dates périmées. */
(function () {
  'use strict';

  function nombre(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; }
  function echapper(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Heure de Paris, quel que soit le fuseau du visiteur */
  function maintenantParis() {
    var parts = new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return { annee: +o.year, mois: +o.month, jour: +o.day, heure: (+o.hour) % 24, minute: +o.minute };
  }

  function cle(d) {
    var m = d.getMonth() + 1, j = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (j < 10 ? '0' : '') + j;
  }

  function Frise(racine) {
    this.r = racine;
    var ds = racine.dataset;
    this.min = nombre(ds.min, 5);
    this.max = nombre(ds.max, 8);
    if (this.max < this.min) { var t = this.min; this.min = this.max; this.max = t; }
    this.prep = nombre(ds.preparation, 1);
    this.limite = nombre(ds.limite, 14);
    this.samedi = ds.samedi === 'true';
    this.format = ds.format || 'numerique';
    this.rebours = ds.rebours === 'true';
    this.feries = {};
    var self = this;
    (ds.feries || '').split(/[\s,;]+/).forEach(function (x) {
      if (/^\d{4}-\d{2}-\d{2}$/.test(x)) self.feries[x] = true;
    });
    this.dispo = ds.dispo !== 'false';
    this.variantes = {};
    var json = racine.querySelector('[data-frise-variantes]');
    if (json) { try { this.variantes = JSON.parse(json.textContent); } catch (e) {} }
  }

  Frise.prototype.estOuvre = function (d) {
    var j = d.getDay();
    if (j === 0) return false;
    if (j === 6 && !this.samedi) return false;
    return !this.feries[cle(d)];
  };
  Frise.prototype.prochainOuvre = function (d) {
    var x = new Date(d);
    do { x.setDate(x.getDate() + 1); } while (!this.estOuvre(x));
    return x;
  };
  Frise.prototype.ajouterOuvres = function (d, n) {
    var x = new Date(d), c = 0;
    while (c < n) { x.setDate(x.getDate() + 1); if (this.estOuvre(x)) c++; }
    return x;
  };
  Frise.prototype.formater = function (d) {
    var s;
    if (this.format === 'numerique') {
      var j = d.getDate(), m = d.getMonth() + 1;
      return (j < 10 ? '0' : '') + j + '/' + (m < 10 ? '0' : '') + m;
    }
    var opts = this.format === 'court' ? { day: 'numeric', month: 'short' }
             : this.format === 'jour_mois' ? { day: 'numeric', month: 'long' }
             : { weekday: 'long', day: 'numeric', month: 'long' };
    s = d.toLocaleDateString('fr-FR', opts);
    /* Le navigateur écrit « 1 octobre » : en français, c'est « 1er octobre ». */
    return s.replace(/(^|\s)1(\s)/, '$11er$2');
  };

  /* Calcul pur, testable sans page : renvoie les trois dates de la frise */
  Frise.prototype.calculer = function () {
    var p = maintenantParis();
    /* Midi local : l'arithmétique des dates reste insensible aux changements d'heure */
    var aujourdhui = new Date(p.annee, p.mois - 1, p.jour, 12);
    var avantLimite = this.estOuvre(aujourdhui) && p.heure < this.limite;
    var depart = avantLimite ? aujourdhui : this.prochainOuvre(aujourdhui);
    var preparation = this.prep > 0 ? this.ajouterOuvres(depart, this.prep) : depart;
    var debut = this.ajouterOuvres(depart, this.min);
    var fin = this.ajouterOuvres(depart, this.max);
    var reste = avantLimite ? (this.limite * 60) - (p.heure * 60 + p.minute) : 0;
    return {
      commande: this.formater(aujourdhui),
      preparation: this.formater(preparation),
      debut: this.formater(debut),
      fin: this.formater(fin),
      avantLimite: avantLimite,
      resteMinutes: reste
    };
  };

  Frise.prototype.rendre = function () {
    var r = this.r;
    var contenu = r.querySelector('[data-frise-contenu]');
    var rupture = r.querySelector('[data-frise-rupture]');
    var reboursEl = r.querySelector('[data-frise-rebours]');

    if (!this.dispo) {
      if (r.dataset.ruptureMode === 'masquer') { r.hidden = true; return; }
      r.hidden = false;
      if (contenu) contenu.hidden = true;
      if (reboursEl) reboursEl.hidden = true;
      if (rupture) rupture.hidden = false;
      return;
    }
    r.hidden = false;
    if (contenu) contenu.hidden = false;
    if (rupture) rupture.hidden = true;

    var c = this.calculer();
    var d1 = r.querySelector('[data-frise-date="1"]');
    var d2 = r.querySelector('[data-frise-date="2"]');
    var d3 = r.querySelector('[data-frise-date="3"]');
    if (d1) d1.textContent = c.commande;
    if (d2) d2.textContent = c.preparation;
    if (d3) d3.textContent = c.debut === c.fin ? c.debut : c.debut + ' – ' + c.fin;

    if (reboursEl) {
      if (this.rebours && c.avantLimite && c.resteMinutes > 0) {
        var h = Math.floor(c.resteMinutes / 60), m = c.resteMinutes % 60;
        var temps = (h > 0 ? h + ' h ' : '') + m + ' min';
        reboursEl.innerHTML = echapper(r.dataset.reboursTexte || '')
          .replace(/\{temps\}/g, '<strong class="apfr__temps">' + echapper(temps) + '</strong>')
          .replace(/\{debut\}/g, '<strong>' + echapper(c.debut) + '</strong>')
          .replace(/\{fin\}/g, '<strong>' + echapper(c.fin) + '</strong>');
        reboursEl.hidden = false;
      } else {
        reboursEl.hidden = true;
      }
    }
  };

  function initialiser(racine) {
    if (racine.__apFrise) return;
    var f = new Frise(racine);
    racine.__apFrise = f;

    /* La date n'a de sens que si la variante choisie est disponible */
    var select = document.querySelector('[data-variantes]');
    if (select) {
      select.addEventListener('change', function () {
        if (Object.prototype.hasOwnProperty.call(f.variantes, select.value)) {
          f.dispo = f.variantes[select.value] === true;
          f.rendre();
        }
      });
    }
    f.rendre();
    if (f.rebours) setInterval(function () { f.rendre(); }, 30000);
  }

  function tout() { document.querySelectorAll('[data-frise]').forEach(initialiser); }

  window.AspadelFrise = Frise;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  document.addEventListener('shopify:section:load', tout);
  document.addEventListener('shopify:block:select', tout);
})();
